import { render, staticRenderFns } from "./CircleExclamationMarkIcon.vue?vue&type=template&id=304781f2&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports